import React, { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import styled from 'styled-components'

import { ClickWrapAdditionalActionsComponent } from '../../../clickwrap/types'
import * as Styled from '../styled'

const RxDFHendUSMay2021ContentActions: ClickWrapAdditionalActionsComponent<{
  className?: string
}> = ({ className, defaultChecked = false, disabled = true, onChanged, readonly = false }) => {
  const { register, watch } = useForm()
  const { LiquidatedDamagesClauseAcceptance, UnderstandRxDFHendAgreementAcceptance } = watch([
    'LiquidatedDamagesClauseAcceptance',
    'UnderstandRxDFHendAgreementAcceptance',
  ])

  const isComplete = LiquidatedDamagesClauseAcceptance && UnderstandRxDFHendAgreementAcceptance

  useEffect(() => {
    onChanged({ isComplete })
  }, [isComplete, onChanged])

  return (
    <Styled.AdditionalActionsContainer className={className}>
      <Styled.Checkbox
        label={
          <Styled.CheckboxLabel disabled={disabled} readonly={readonly}>
            By checking this box, I signify that I have read the Liquidated Damages clause above,
            and I understand that I may be liable to Designs for Health to pay liquidated damages in
            the event of my breach of this RxDFHend Agreement.
          </Styled.CheckboxLabel>
        }
        id="LiquidatedDamagesClauseAcceptance"
        name="LiquidatedDamagesClauseAcceptance"
        readonly={readonly}
        register={register}
        value=""
        disabled={disabled}
        defaultChecked={defaultChecked}
      />
      <Styled.Checkbox
        label={
          <Styled.CheckboxLabel disabled={disabled}>
            By checking this box and clicking &quot;I Agree&quot; below, I signify that I have read
            and I understand this RxDFHend Agreement and that I, as the healthcare practitioner
            linked to this wholesale account, am legally bound by these terms.
          </Styled.CheckboxLabel>
        }
        id="UnderstandRxDFHendAgreementAcceptance"
        name="UnderstandRxDFHendAgreementAcceptance"
        readonly={readonly}
        register={register}
        value=""
        disabled={disabled}
        defaultChecked={defaultChecked}
      />
    </Styled.AdditionalActionsContainer>
  )
}

const StyledRxDFHendUSMay2021ContentActions = styled(RxDFHendUSMay2021ContentActions)``

export default StyledRxDFHendUSMay2021ContentActions
